import { Link } from "react-router-dom";

import "../../styles/pages/NotFound.css";

const NotFound = () => {
  return (
    <main className="not-found-page position-relative d-flex align-items-center overflow-hidden">
      {/* Background grid */}
      <div className="not-found-grid position-absolute top-0 start-0 w-100 h-100" />
      {/* Background 404 */}
      <div className="not-found-watermark position-absolute top-50 start-50 translate-middle">
        404
      </div>
      <div className="container position-relative">
        <div className="row justify-content-center">
          <div className="col-lg-8 col-xl-7 text-center">
            {/* Label */}
            <span className="not-found-label d-inline-block font-monospace text-danger mb-4">
              ERROR / 404
            </span>
            {/* Code */}
            <h1 className="not-found-code fw-bold text-danger mb-0">404</h1>
            {/* Heading */}
            <h2 className="not-found-title fw-bold mb-3">This page doesn't exist.</h2>
            {/* Description */}
            <p className="not-found-description text-secondary mx-auto mb-4">
              The page you're looking for may have been moved, deleted, or never existed in the
              first place.
            </p>
            {/* Terminal message */}
            <div className="not-found-terminal d-inline-flex align-items-center gap-2 font-monospace px-3 py-2 mb-4">
              <span className="text-danger">›</span>
              <span className="text-secondary">route_not_found</span>
              <span className="terminal-cursor bg-danger" />
            </div>
            {/* Actions */}
            <div className="d-flex flex-column flex-sm-row justify-content-center gap-3">
              <Link
                to="/"
                className="btn btn-danger btn-lg d-inline-flex align-items-center justify-content-center gap-2"
              >
                Back to Home
                <span>→</span>
              </Link>
              <Link
                to="/projects"
                className="btn btn-outline-light btn-lg d-inline-flex align-items-center justify-content-center gap-2"
              >
                Explore Our Work
              </Link>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default NotFound;
